import { CellKeyFieldsPartial } from '../typings/common';
import { PhraseBidChange, PhraseChange } from '../typings/domain';
import { SearchAndReplaceFormValue, SearchAndReplacePreviewData } from '../typings/searchAndReplace';

export const UPDATE_PHRASE_REMOTE = 'UPDATE_PHRASE_REMOTE';
export type UPDATE_PHRASE_REMOTE = typeof UPDATE_PHRASE_REMOTE;

export interface UpdatePhraseRemoteAction {
    type: UPDATE_PHRASE_REMOTE;
    phrase: PhraseChange;
    cellKeyPartial: CellKeyFieldsPartial;
}

export function updatePhraseRemote(phrase: PhraseChange, columnName: string): UpdatePhraseRemoteAction {
    return {
        type: UPDATE_PHRASE_REMOTE,
        phrase,
        cellKeyPartial: {
            id: phrase.id,
            column: columnName
        }
    };
}

export const UPDATE_PHRASE = 'UPDATE_PHRASE';
export type UPDATE_PHRASE = typeof UPDATE_PHRASE;

export interface UpdatePhrase {
    type: UPDATE_PHRASE;
    phrase: PhraseChange;
}

export function onUpdatePhrase(phrase: PhraseChange): UpdatePhrase {
    return {
        type: UPDATE_PHRASE,
        phrase
    };
}

export const UPDATE_PHRASE_BID = 'UPDATE_PHRASE_BID';
export type UPDATE_PHRASE_BID = typeof UPDATE_PHRASE_BID;

export interface UpdatePhraseBidAction {
    type: UPDATE_PHRASE_BID;
    phrase: PhraseBidChange;
}

export function updatePhraseBid(phrase: PhraseBidChange): UpdatePhraseBidAction {
    return {
        type: UPDATE_PHRASE_BID,
        phrase
    };
}

export const UPDATE_PHRASES_PREVIEW = 'UPDATE_PHRASES_PREVIEW';
export type UPDATE_PHRASES_PREVIEW = typeof UPDATE_PHRASES_PREVIEW;
export interface UpdatePhrasesPreview {
    type: UPDATE_PHRASES_PREVIEW;
    preview: SearchAndReplacePreviewData;
}
export function updateSearchAndReplaceInspectorPreview(preview: SearchAndReplacePreviewData): UpdatePhrasesPreview {
    return {
        type: UPDATE_PHRASES_PREVIEW,
        preview
    };
}

export const GET_PHRASE_REPLACE_PREVIEW = 'GET_PHRASE_REPLACE_PREVIEW';
export type GET_PHRASE_REPLACE_PREVIEW = typeof GET_PHRASE_REPLACE_PREVIEW;
export interface GetPhraseReplacePreview {
    type: GET_PHRASE_REPLACE_PREVIEW;
}
export function getPhraseReplacePreview(): GetPhraseReplacePreview {
    return {
        type: GET_PHRASE_REPLACE_PREVIEW
    };
}

export const SWITCH_SEARCH_AND_REPLACE_INSPECTOR_VISIBILITY = 'SWITCH_SEARCH_AND_REPLACE_INSPECTOR_VISIBILITY';
export type SWITCH_SEARCH_AND_REPLACE_INSPECTOR_VISIBILITY = typeof SWITCH_SEARCH_AND_REPLACE_INSPECTOR_VISIBILITY;

export interface SwitchSearchAndReplaceInspectorVisibility {
    type: SWITCH_SEARCH_AND_REPLACE_INSPECTOR_VISIBILITY;
    visible: boolean;
}

export function switchSearchAndReplaceInspectorVisibility(visible: boolean): SwitchSearchAndReplaceInspectorVisibility {
    return {
        type: SWITCH_SEARCH_AND_REPLACE_INSPECTOR_VISIBILITY,
        visible
    };
}

export const REPLACE_PHRASES = 'REPLACE_PHRASE';
export type REPLACE_PHRASE = typeof REPLACE_PHRASES;

export interface ReplacePhrases {
    type: REPLACE_PHRASE;
}

export function replacePhrases(): ReplacePhrases {
    return {
        type: REPLACE_PHRASES
    };
}

export const SHOW_REPLACE_PHRASES_ERROR = 'SHOW_REPLACE_PHRASES_ERROR';
export type SHOW_REPLACE_PHRASES_ERROR = typeof SHOW_REPLACE_PHRASES_ERROR;
export interface ShowReplacePhrasesError {
    type: SHOW_REPLACE_PHRASES_ERROR;
    error?: string;
}
export function showReplacePhrasesError(error: string): ShowReplacePhrasesError {
    return {
        type: SHOW_REPLACE_PHRASES_ERROR,
        error: error
    };
}

export const CLEAR_REPLACE_PHRASES_ERROR = 'CLEAR_REPLACE_PHRASES_ERROR';
export type CLEAR_REPLACE_PHRASES_ERROR = typeof CLEAR_REPLACE_PHRASES_ERROR;
export interface ClearReplacePhrasesError {
    type: CLEAR_REPLACE_PHRASES_ERROR;
}
export function clearReplacePhrasesError(): ClearReplacePhrasesError {
    return {
        type: CLEAR_REPLACE_PHRASES_ERROR
    };
}

export const FINISH_SEARCH_AND_REPLACE_LOADING = 'FINISH_SEARCH_AND_REPLACE_LOADING';
export type FINISH_SEARCH_AND_REPLACE_LOADING = typeof FINISH_SEARCH_AND_REPLACE_LOADING;
export interface FinishSearchAndReplaceLoading {
    type: FINISH_SEARCH_AND_REPLACE_LOADING;
    successMessage?: string;
}
export function finishSearchAndReplaceLoading(successMessage?: string): FinishSearchAndReplaceLoading {
    return {
        type: FINISH_SEARCH_AND_REPLACE_LOADING,
        successMessage
    };
}

export const RESET_SEARCH_AND_REPLACE_INSPECTOR_STATE = 'RESET_SEARCH_AND_REPLACE_INSPECTOR_STATE';
export type RESET_SEARCH_AND_REPLACE_INSPECTOR_STATE = typeof RESET_SEARCH_AND_REPLACE_INSPECTOR_STATE;
export interface ResetSearchAndReplaceInspectorState {
    type: RESET_SEARCH_AND_REPLACE_INSPECTOR_STATE;
}
export function resetSearchAndReplaceInspectorState(): ResetSearchAndReplaceInspectorState {
    return {
        type: RESET_SEARCH_AND_REPLACE_INSPECTOR_STATE
    };
}

export const UPDATE_SEARCH_AND_REPLACE_INSPECTOR_VALUE = 'UPDATE_SEARCH_AND_REPLACE_INSPECTOR_VALUE';
export type UPDATE_SEARCH_AND_REPLACE_INSPECTOR_VALUE = typeof UPDATE_SEARCH_AND_REPLACE_INSPECTOR_VALUE;
interface UpdateSearchAndReplaceInspectorValue {
    type: UPDATE_SEARCH_AND_REPLACE_INSPECTOR_VALUE;
    value: SearchAndReplaceFormValue;
}
export function updateSearchAndReplaceInspectorValue(
    value: SearchAndReplaceFormValue
): UpdateSearchAndReplaceInspectorValue {
    return {
        type: UPDATE_SEARCH_AND_REPLACE_INSPECTOR_VALUE,
        value
    };
}

export const UPDATE_PHRASE_BID_REMOTE = 'UPDATE_PHRASE_BID_REMOTE';
export type UPDATE_PHRASE_BID_REMOTE = typeof UPDATE_PHRASE_BID_REMOTE;

export interface UpdatePhraseBidRemoteAction {
    type: UPDATE_PHRASE_BID_REMOTE;
    phrase: PhraseBidChange;
    cellKeyPartial: CellKeyFieldsPartial;
}

export function updatePhraseBidRemote(phrase: PhraseBidChange, columnName: string): UpdatePhraseBidRemoteAction {
    return {
        type: UPDATE_PHRASE_BID_REMOTE,
        phrase,
        cellKeyPartial: {
            column: columnName,
            id: phrase.id
        }
    };
}

export const SAVE_PHRASES_MASS_COMMON_PRICE_EDITOR = 'SAVE_PHRASES_MASS_COMMON_PRICE_EDITOR';
export type SAVE_PHRASES_MASS_COMMON_PRICE_EDITOR = typeof SAVE_PHRASES_MASS_COMMON_PRICE_EDITOR;

export interface SavePhrasesMassCommonPriceEditor {
    type: SAVE_PHRASES_MASS_COMMON_PRICE_EDITOR;
}

export const savePhrasesMassCommonPriceEditor = (): SavePhrasesMassCommonPriceEditor => {
    return {
        type: SAVE_PHRASES_MASS_COMMON_PRICE_EDITOR
    };
};

export type PhrasesGridAction =
    | SavePhrasesMassCommonPriceEditor
    | UpdatePhraseRemoteAction
    | UpdatePhrase
    | SwitchSearchAndReplaceInspectorVisibility
    | UpdatePhrasesPreview
    | ReplacePhrases
    | GetPhraseReplacePreview
    | ShowReplacePhrasesError
    | ClearReplacePhrasesError
    | FinishSearchAndReplaceLoading
    | ResetSearchAndReplaceInspectorState
    | UpdateSearchAndReplaceInspectorValue
    | UpdatePhraseBidRemoteAction
    | UpdatePhraseBidAction;
